import Vue from 'vue'
import Vuex from 'vuex'
import VueMeta from 'vue-meta'

Vue.use(Vuex)
Vue.use(VueMeta)

export default new Vuex.Store({
  state: {
    authUser: null,
    browseMenuOpened: true,
    dayList: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(e => ({ name: e, short: e.substr(3), shortest: e.substr(1) })),
    htmlScrollTop: 0,
    isFullLoading: false,
    locale: 'en',
    locales: [{ name: 'English', val: 'en' }, { name: 'ภาษาไทย', val: 'th' }],
    monthList: [
      { id: 1, name: 'January', short: 'Jan', count: 31 },
      { id: 2, name: 'February', short: 'Feb', count: 29 },
      { id: 3, name: 'March', short: 'Mar', count: 31 },
      { id: 4, name: 'April', short: 'Apr', count: 30 },
      { id: 5, name: 'May', short: 'May', count: 31 },
      { id: 6, name: 'June', short: 'Jun', count: 30 },
      { id: 7, name: 'July', short: 'Jul', count: 31 },
      { id: 8, name: 'August', short: 'Aug', count: 31 },
      { id: 9, name: 'September', short: 'Sep', count: 30 },
      { id: 10, name: 'October', short: 'Oct', count: 31 },
      { id: 11, name: 'November', short: 'Nov', count: 30 },
      { id: 12, name: 'December', short: 'Dec', count: 31 }
    ],
    swiper: null,
    version: '05012021',
    windowHeight: 600,
    windowWidth: 0,
    color: {
      'primary': '#FF2E38',
      'secondary': '#3D87FF',
      'tertiary': '#B452FF',
      'semanticRed': '#FF2E38',
      'semanticYellow': '#DB9A00',
      'semanticOrange': '#F55200',
      'semanticBlue': '#3D87FF',
      'semanticBluegreen': '#00B8CC',
      'semanticGreen': '#00B33C',
      'semanticViolet': '#B452FF',
      'semanticPink': '#FF2970',
      'coolGrey': '#9296A0',
      'primary-25': '#fff1ef',
      'primary-50': '#fff1ef',
      'primary-100': '#ffdad4',
      'primary-200': '#ffb9b0',
      'primary-300': '#ff9187',
      'primary-400': '#ff615e',
      'primary-500': '#ff2e38',
      'primary-600': '#de0022',
      'primary-700': '#ba0015',
      'primary-800': '#950011',
      'primary-900': '#720c12',
      'primary-925': '#521313',
      'primary-950': '#361412',
      'primary-975': '#1e100f',
      'secondary-25': '#eff7ff',
      'secondary-50': '#eff7ff',
      'secondary-100': '#d5ecff',
      'secondary-200': '#b2dcff',
      'secondary-300': '#8bc5ff',
      'secondary-400': '#62a8ff',
      'secondary-500': '#3d87ff',
      'secondary-600': '#286edf',
      'secondary-700': '#1b59bb',
      'secondary-800': '#164797',
      'secondary-900': '#143872',
      'secondary-925': '#142b51',
      'secondary-950': '#121f34',
      'secondary-975': '#0f141d',
      'tertiary-25': '#fbf3ff',
      'tertiary-50': '#fbf3ff',
      'tertiary-100': '#f7dfff',
      'tertiary-200': '#f0c3ff',
      'tertiary-300': '#e4a1ff',
      'tertiary-400': '#d07aff',
      'tertiary-500': '#b452ff',
      'tertiary-600': '#9a39df',
      'tertiary-700': '#7f29bb',
      'tertiary-800': '#662196',
      'tertiary-900': '#4e1e72',
      'tertiary-925': '#391b51',
      'tertiary-950': '#261734',
      'tertiary-975': '#17111d',
      'semanticRed-25': '#fff1ef',
      'semanticRed-50': '#fff1ef',
      'semanticRed-100': '#ffdad4',
      'semanticRed-200': '#ffb9b0',
      'semanticRed-300': '#ff9187',
      'semanticRed-400': '#ff615e',
      'semanticRed-500': '#ff2e38',
      'semanticRed-600': '#de0022',
      'semanticRed-700': '#ba0015',
      'semanticRed-800': '#950011',
      'semanticRed-900': '#720c12',
      'semanticRed-925': '#521313',
      'semanticRed-950': '#361412',
      'semanticRed-975': '#1e100f',
      'semanticYellow-25': '#fff8ee',
      'semanticYellow-50': '#fff8ee',
      'semanticYellow-100': '#ffedcf',
      'semanticYellow-200': '#ffdea7',
      'semanticYellow-300': '#fcca78',
      'semanticYellow-400': '#f0b345',
      'semanticYellow-500': '#db9a00',
      'semanticYellow-600': '#bb7e00',
      'semanticYellow-700': '#9c6700',
      'semanticYellow-800': '#7d5300',
      'semanticYellow-900': '#614100',
      'semanticYellow-925': '#47320d',
      'semanticYellow-950': '#312513',
      'semanticYellow-975': '#1e1a12',
      'semanticOrange-25': '#fff3ed',
      'semanticOrange-50': '#fff3ed',
      'semanticOrange-100': '#ffdfce',
      'semanticOrange-200': '#ffc2a5',
      'semanticOrange-300': '#ffa076',
      'semanticOrange-400': '#ff7843',
      'semanticOrange-500': '#f55200',
      'semanticOrange-600': '#d43900',
      'semanticOrange-700': '#b22800',
      'semanticOrange-800': '#8f2100',
      'semanticOrange-900': '#6d1e00',
      'semanticOrange-925': '#4f1c0a',
      'semanticOrange-950': '#34180e',
      'semanticOrange-975': '#1e120e',
      'semanticBlue-25': '#eff7ff',
      'semanticBlue-50': '#eff7ff',
      'semanticBlue-100': '#d5ecff',
      'semanticBlue-200': '#b2dcff',
      'semanticBlue-300': '#8bc5ff',
      'semanticBlue-400': '#62a8ff',
      'semanticBlue-500': '#3d87ff',
      'semanticBlue-600': '#286edf',
      'semanticBlue-700': '#1b59bb',
      'semanticBlue-800': '#164797',
      'semanticBlue-900': '#143872',
      'semanticBlue-925': '#142b51',
      'semanticBlue-950': '#121f34',
      'semanticBlue-975': '#0f141d',
      'semanticBluegreen-25': '#f0fbfd',
      'semanticBluegreen-50': '#f0fbfd',
      'semanticBluegreen-100': '#d5f6fc',
      'semanticBluegreen-200': '#afeef9',
      'semanticBluegreen-300': '#82e2f1',
      'semanticBluegreen-400': '#4dd0e3',
      'semanticBluegreen-500': '#00b8cc',
      'semanticBluegreen-600': '#009bae',
      'semanticBluegreen-700': '#008090',
      'semanticBluegreen-800': '#006774',
      'semanticBluegreen-900': '#00505a',
      'semanticBluegreen-925': '#0f3c42',
      'semanticBluegreen-950': '#142a2d',
      'semanticBluegreen-975': '#131b1c',
      'semanticGreen-25': '#effbef',
      'semanticGreen-50': '#effbef',
      'semanticGreen-100': '#d4f8d5',
      'semanticGreen-200': '#aff0b3',
      'semanticGreen-300': '#81e38b',
      'semanticGreen-400': '#4dcf62',
      'semanticGreen-500': '#00b33c',
      'semanticGreen-600': '#009723',
      'semanticGreen-700': '#007d15',
      'semanticGreen-800': '#006412',
      'semanticGreen-900': '#004e14',
      'semanticGreen-925': '#0d3915',
      'semanticGreen-950': '#112814',
      'semanticGreen-975': '#101911',
      'semanticViolet-25': '#fbf3ff',
      'semanticViolet-50': '#fbf3ff',
      'semanticViolet-100': '#f7dfff',
      'semanticViolet-200': '#f0c3ff',
      'semanticViolet-300': '#e4a1ff',
      'semanticViolet-400': '#d07aff',
      'semanticViolet-500': '#b452ff',
      'semanticViolet-600': '#9a39df',
      'semanticViolet-700': '#7f29bb',
      'semanticViolet-800': '#662196',
      'semanticViolet-900': '#4e1e72',
      'semanticViolet-925': '#391b51',
      'semanticViolet-950': '#261734',
      'semanticViolet-975': '#17111d',
      'semanticPink-25': '#fff1f3',
      'semanticPink-50': '#fff1f3',
      'semanticPink-100': '#ffd9e1',
      'semanticPink-200': '#ffb7c9',
      'semanticPink-300': '#ff8ead',
      'semanticPink-400': '#ff5e8e',
      'semanticPink-500': '#ff2970',
      'semanticPink-600': '#dd005a',
      'semanticPink-700': '#b90048',
      'semanticPink-800': '#950039',
      'semanticPink-900': '#72092d',
      'semanticPink-925': '#521223',
      'semanticPink-950': '#36131b',
      'semanticPink-975': '#1f1013',
      'coolGrey-25': '#f7f7f8',
      'coolGrey-50': '#f7f7f8',
      'coolGrey-100': '#ebecf0',
      'coolGrey-200': '#dbdde3',
      'coolGrey-300': '#c6c9d1',
      'coolGrey-400': '#aeb2bb',
      'coolGrey-500': '#9296a0',
      'coolGrey-600': '#797d86',
      'coolGrey-700': '#63666e',
      'coolGrey-800': '#4f5258',
      'coolGrey-900': '#3e4044',
      'coolGrey-925': '#2e3033',
      'coolGrey-950': '#212224',
      'coolGrey-975': '#161617'
    },
    project_type: [],
    framework: 'vue',
    contentTypeNameToApp: {
      activity: 'activity',
      article: 'article',
      audio: 'audio',
      buffet: 'buffet',
      class: 'event',
      class_program: 'event-program',
      'class-program': 'event-program',
      content_program: 'content-program',
      course: 'course',
      course_coniclex: 'course',
      credit: 'ticket',
      document: 'document',
      external_training: 'external-training',
      external_video: 'external-video',
      event: 'event',
      flash_card: 'flash-card',
      learning_history: 'learning-history',
      learningpath: 'learning-path',
      learning_path: 'learning-path',
      pathway: 'learning-path',
      learning_playlist: 'playlist',
      live: 'live',
      onboard: 'onboard',
      public_learning: 'public-learning',
      public_request: 'public-request',
      survey: 'survey',
      test: 'exam',
      video: 'video',
      video_coniclex: 'video',
      audio_coniclex: 'audio',
      article_coniclex: 'article',
      external_video_coniclex: 'external-video',
      document_coniclex: 'document',
      flash_card_coniclex: 'flash-card'
    },
    contentTypeAppToName: {
      activity: 'activity',
      article: 'article',
      audio: 'audio',
      class: 'class',
      class_program: 'class_program',
      content_program: 'learning_program',
      course: 'course',
      course_coniclex: 'course',
      event: 'class',
      event_program: 'class_program',
      exam: 'test',
      external_training: 'external_training',
      external_video: 'external_video',
      document: 'document',
      learning_content: 'learning_material',
      learning_content_coniclex: 'learning_material',
      learning_history: 'learning_history',
      learning_path: 'learning_path',
      learning_program: 'learning_program',
      learning_material: 'learning_material',
      learning_playlist: 'learning_playlist',
      live: 'live',
      online_learning_path: 'learning_path',
      public_learning: 'public_learning',
      public_request: 'public_request',
      playlist: 'learning_playlist',
      schedule_learning_path: 'learning_path',
      survey: 'survey',
      video: 'video'
    },
    domain: null,
    projectID: `${Math.random().toString(36).substring(2, 15)}${Math.random().toString(36).substring(2, 15)}`.replace(/[0-9]/g, ''),
    staticUrl: '/'
  },

  mutations: {
    SET_STATE (state, { name, key, key2, val }) {
      if (key2) state[name][key][key2] = val
      else if (key) state[name][key] = val
      else state[name] = val
    },
    SET_AUTH_USER (state, user) {
      state.authUser = user
    }
  },

  actions: {
    async setLanguage ({ state, commit, dispatch }, { lang, i18nContext, context }) {
      if (i18nContext) window.i18n = i18nContext
      const check = state.locales.find(e => e.val === lang)
      const language = (check && lang) || 'en'
      commit('SET_STATE', { name: 'locale', val: language })
      return language
    },

    async checkAuthen ({ state, commit }) {
      const authUserString = sessionStorage.getItem('authUser')
      const authUser = JSON.parse(authUserString)
      if (authUser && Object.keys(authUser).length) {
        // Update the store with the authenticated user
        commit('SET_AUTH_USER', authUser)
        return true
      } else if (state.authUser && state.authUser.accessToken) {
        // User is authenticated in the store
        return true
      } else {
        // User is not authenticated
        return false
      }
    }
  }
})
